/* eslint-disable no-shadow */
enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export default Theme;
